import { Duration } from 'date-fns';
import { subscriptionPeriodSchema } from '../../schema/upscribe';

export function getDurationForSubscription(interval: number, period: string): Duration {
  const { day, week, month, days, weeks, months } = subscriptionPeriodSchema.enum;
  const parsedPeriod = period.toLowerCase();

  return {
    days: parsedPeriod === day || parsedPeriod === days ? interval : 0,
    weeks: parsedPeriod === week || parsedPeriod === weeks ? interval : 0,
    months: parsedPeriod === month || parsedPeriod === months ? interval : 0
  };
}
